import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import {
  ISignSigSubjectInfoCheckResultResponse,
  ISignSubjectInfo,
  ISignSubjectInfoCheckResult,
} from 'APIPackage/KnmModule/interfaces/ISignSubjectInfo';
import { IPlanFormValues } from 'PlanPackage/MainModule/interfaces/PlanForm';

import { IKnmAttachment } from '../interfaces/IKnmAttachment';
import { ISign } from '../interfaces/ISign';
import { IKnm } from '../interfaces/IKnm';

export async function fetchKnmHash(id: number): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/xml`, false, true);
}

export async function knmCheckSignCertificate(
  subjectInfo: ISignSubjectInfo,
  id?: number,
): Promise<ISignSubjectInfoCheckResult> {
  return apiPost<ISignSubjectInfoCheckResult>({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/check-certificate-fields`,
    body: subjectInfo,
  });
}

export async function signKnm(signature: string, id?: number): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/signature/knm/${id}`, body: signature });
}

export async function signErknm(id: number, params: IKnmAttachment): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/sign-xml/${id}`, params);
}

export async function deleteKnmSignById(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/signature`);
}

export async function downloadSignedZipById(id: number): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/download/zip`);
}

export async function fetchSignUpload(file: File, id: number): Promise<ISignSigSubjectInfoCheckResultResponse> {
  const formData = new FormData();

  formData.append('file', file);

  return apiPost<ISignSigSubjectInfoCheckResultResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/signature/knm/${id}/upload`,
    body: formData,
  });
}

export async function fetchSignKnm(data: ISign): Promise<boolean> {
  const { id, document, file, signature, fileName, actGuid, prescriptionGuid, isCancelSign, withPlan } = data;
  const formData = new FormData();

  formData.append('file', file);
  formData.append('document', document);
  formData.append('signature', signature);
  formData.append('fileName', fileName);
  if (actGuid) formData.append('actGuid', actGuid);
  if (prescriptionGuid) formData.append('prescriptionGuid', prescriptionGuid);
  if (isCancelSign) formData.append('isCancelSign', String(isCancelSign));
  if (withPlan) formData.append('withPlan', String(withPlan));

  return apiPost<boolean>({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/sign-knm/${id}`,
    body: formData,
  });
}

export async function putSignerKnm(knmId: IKnm['id'], form: IPlanFormValues): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/signer`, { ...form, knmId });
}

export async function fetchSignTestKnm(data: { id: number }): Promise<boolean> {
  const { id } = data;

  return apiPost<boolean>({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/sign-test-knm/${id}`,
  });
}

export async function updateKnmControlObjects(passportId: number, cosIds: string[]) {
  return apiPost<boolean>({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/update-control-objects`,
    body: { cosIds, id: passportId },
  });
}
